export { default } from "./BPVRapport";
